import { render, staticRenderFns } from "./HomeEbook.vue?vue&type=template&id=22282419&"
import script from "./HomeEbook.vue?vue&type=script&lang=js&"
export * from "./HomeEbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports